module.exports = __webpack_public_path__ + "img/p07.22424051.jpg";